import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { LanguageCodeStorageKey, SupportedLanguages } from './constants';
import { fallback } from './fallback';
const languageDetector = new LanguageDetector();
/**
 * Initialize i18next instance and use fallback translations if consumer does not use I18nProvider
 */
i18next.use(languageDetector).init({
    detection: {
        lookupCookie: LanguageCodeStorageKey,
        lookupLocalStorage: LanguageCodeStorageKey,
        lookupSessionStorage: LanguageCodeStorageKey,
    },
    fallbackLng: SupportedLanguages.enUS,
    interpolation: {
        escapeValue: false,
    },
    partialBundledLanguages: true,
    resources: fallback,
    supportedLngs: Object.values(SupportedLanguages),
});
export { i18next as i18nextDefaultInstance };
//# sourceMappingURL=i18nextDefaultInstance.js.map